import React from 'react';
import { stack } from '../../data/products';
import { useReveal } from '../../hooks/useReveal';
import './Stack.scss';

const Stack = () => {
    const [ref, revealed] = useReveal({ threshold: 0.15 });

    return (
        <section className="lab-stack" id="stack" ref={ref}>
            <div className={`ls-inner ${revealed ? 'is-in' : ''}`}>
                <div className="ls-head">
                    <span className="ls-eyebrow">Technology</span>
                    <h2 className="ls-title">The stack behind the lab.</h2>
                </div>

                <div className="ls-grid">
                    {stack.map((group, i) => (
                        <div className="ls-group" key={group.group} style={{ '--i': i }}>
                            <h3 className="ls-group-title">
                                <span className="ls-group-index">
                                    {String(i + 1).padStart(2, '0')}
                                </span>
                                {group.group}
                            </h3>
                            <ul className="ls-items">
                                {group.items.map((item) => (
                                    <li key={item}>{item}</li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Stack;
